const data = [
  {
    className : "icon-icn_camera",
    header : "Take a photo" ,
    subHeading : "We need this to verify your package"
  },
  {
      className : "icon-icn_note",
      header : "Package Details" ,
      subHeading : "Size, contents & value"
  },
  {
    className : "icon-icn_smiley",
    header : "Pickup Location" ,
    subHeading : "Location and person picking up the package"
  },
  {
    className : "icon-icn_package_location",
    header : "Delivery Location" ,
    subHeading : "Location and person picking up the package"
  },
  {
    className : "icon-icn_wallet",
    header : "Payment" ,
    subHeading : "Confirm payment and finish"
  }
]

export default data;



// WEBPACK FOOTER //
// app/post_a_shipment/post_a_shipment_intro/post_a_shipment_data.jsx